import type { useAppDispatch } from '../grid/reduxStore/Store';
import type { ErrorCode } from '../../../services/socket/SocketEvents';
import { setSaveStatus } from '../grid/reduxStore/saveStatusSlice';
import { DocumentSaveStatus } from '../shared/models/DocumentSaveStatus';
import type { UndoRedoCommandInterface } from './undoRedoCommandVersion';

export type CommandBaseDependencies = {
  dispatch: ReturnType<typeof useAppDispatch>;
  socketClient: any;
  checkDocumentLockStatus: (errorCode: ErrorCode) => boolean;
};

export abstract class CommandBase implements UndoRedoCommandInterface {
  readonly timestamp: string;

  protected readonly dispatch: ReturnType<typeof useAppDispatch>;
  protected readonly socketClient: any;
  protected readonly checkDocumentLockStatus: (errorCode: ErrorCode) => boolean;

  constructor(dependencies: CommandBaseDependencies) {
    this.timestamp = new Date().toISOString();
    this.dispatch = dependencies.dispatch;
    this.socketClient = dependencies.socketClient;
    this.checkDocumentLockStatus = dependencies.checkDocumentLockStatus;
  }

  abstract readonly scope: 'block' | 'section' | 'table' | 'document' | 'global';
  abstract undo(): Promise<boolean>;
  abstract redo(): Promise<boolean>;

  setSaving(): void {
    this.dispatch(setSaveStatus({ status: DocumentSaveStatus.SAVING }));
  }

  setNotSaved(): void {
    this.dispatch(setSaveStatus({ status: DocumentSaveStatus.NOT_SAVED }));
  }
}
